import script from "./Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./Icon.vue?vue&type=script&lang=ts&setup=true"

import "./Icon.vue?vue&type=style&index=0&id=70c9b9be&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c9b9be"]])

export default __exports__